
const useFieldTabIdentifier = ()=> {
    
    const identifyField = (firstErrorField)=> {
        const element = document.getElementById(firstErrorField.id);
        if(element){
            const {tab, innertablevel1:innerTabLevel1} = element.dataset;
            return {tab, innerTabLevel1};
        }
        return {};
    }

    return {identifyField};
}

export {useFieldTabIdentifier};